import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { first, shareReplay } from 'rxjs';
import { IpAddressService } from 'src/app/services/ip-address.service';
import saveAs from 'file-saver';
import { Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-subsidy-to-vendor',
  templateUrl: './subsidy-to-vendor.component.html',
  styleUrls: ['./subsidy-to-vendor.component.scss'],
})
export class SubsidyToVendorComponent implements OnInit {
  @ViewChild('miSurvey', { static: true })
  public miSurvey: Table;

  public userID: any;
  miSurveyData: any[];
  public filteredData: any = [];
  public selectedApplications: any = [];

  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;

  selectedStatus: any;
  items: any[];
  remarks: String;
  date: any;

  ipAddress: any = '000.000.000';

  public loading: boolean = false;
  public subscriptions: any = [];

  filteredDataForExport: any = [];
  appVerificationItems: MenuItem[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];

  public subjectSub:any;
  public selectedYear:any;

  constructor(
    private messageService: MessageService,
    private deptDashBoardService: DepartmentDashboardService,
    private ipService: IpAddressService,
    private router: Router,
    private dashboard: DashboardService,
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService, 
  ) {}

  ngOnInit(): void {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    // this.loadData(this.userID);
    this.loadDataAndApplyFilter();
    this.getIP();

    let actionId = 28; // Do not Change, it is fixed for Farmer Application Verifications
    // this.loader.start();
    this.deptDashBoardService
      .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.items = data.$values;
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master can not be Loaded',
          });
        },
      });

    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(
            this.filteredDataForExport,
            `Filtered Subsidy To Vendor Lot Data_(${this.date})`
          );
        },
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Subsidy To Vendor Lot Data_(${this.date})`);
      //   }
      // },
    ];
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {
        this.loadData(this.userID);
   
        this.selectedYear = res;
        this.miSurvey.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }
  

  loadData(userID) {
    // this.loader.start();
    this.loading = true;
    let sub = this.deptDashBoardService
      .getApplicationsForMISubsidyToVendorLot(userID)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;

          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'Subsidy To Vendor',
          //   '',
          //   new Date(),
          //   'Success'
          // );
          if (data?.length == 0) {
            this.miSurveyData = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'No Data Found',
            });
          } else if (data?.length > 0) {
            this.miSurveyData = data;
            this.miSurveyData = this.miSurveyData.map((row) => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat('_', row.ProgramID),
            }));
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // this.activityRecordService.activityRecord(
          //   this.userID,
          //   'Farmer Share To Vendor',
          //   '',
          //   new Date(),
          //   err
          // );

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });

      this.subscriptions.push(sub);
  }

  onSubmit() {
    // console.log("filtered dataaaa", this.filteredData);
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  handleClick() {
    let newFilteredData = this.filteredData.map((row) => ({
      ...row,
      status: this.selectedStatus.flag,
      remarks: this.remarks ? this.remarks : 'undefined',
    }));

    let reqBody = {
      listLotData: newFilteredData,
      userID: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      subSidyType: 'STV',
      financialyear: ''
    };
    // console.log('reqBody', reqBody);

    
    this.insertMISubsidyLot(reqBody);
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    this.loader.start();
    this.deptDashBoardService
      .insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          if(data == "S:Successfully Submitted" || data == "Success"){
            this.messageService.add({
              severity: 'success',
              summary: 'Status',
              detail: JSON.stringify(data),
            });
            this.filteredDataForExport = [];
            this.loadData(this.userID);
            this.calculation();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: JSON.stringify(data),
            });
          }
          this.loader.close();
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'Full Name in English': d.Full_Name_In_English,
          'Full Name in Recognized Official Language':
            d.Full_Name_in_Recognized_Official_Language,
          'Caste': d?.Caste_Description,
          'GST NO': d.GST_NO,
          'AddressLine1': d.Address_Line_1,
          'AddressLine2': d.Address_Line_2,
          'AddressLine3': d.Address_Line_3,
          'Village': d.Village,
          'Block': d.Block,
          'District': d.District,
          'State': d.State,
          'Country': d.Country,
          'Farmer Type': d.FarmerType,
          'Vendor Bank Name': d.Vendor_Bank_Name,
          'Vendor IFSC Code': d.Vendor_IFSC_Code,
          'Vendor Account Number': d.Vendor_Account_Number
            ? d.Vendor_Account_Number.toString()
            : '',
          'Vendor Pan Card No': d.Vendor_Pan_Card_No,
          'PinCode': d.Pincode,
          'Scheme Specific Id': d.Scheme_Specific_Id,
          'Center Share Payment Amount': d.Center_Share_Payment_Amount,
          'State Share Payment Amount': d.State_Share_Payment_Amount,
          'Top Up': d.TopUp,
          // 'Challan Amount Deposited': d.Farmer_Share_To_Vendor,
          'Application Type': d.ApplicantType,
          'Programme Name': d.Programme_Name,
          'Crop Name': d.Crop_Name,
          'User Type': d.UserType,
          'MI Area': d.MIArea,
          'Total Area': d.Total_Area,
          'FinYear': d.FinYear,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  selectFarmerApplication(application) {
    if (application.Scheme_Specific_Id) {
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
      window.open(link, '_blank');
    } else {
      this.messageService.add({
        summary: 'Error Message',
        severity: 'info',
        detail: 'Application Id Not Found',
      });
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onRowSelect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Selected',
      detail: event.data.name,
    });
  }

  onRowUnselect(event) {
    this.calculation();
    this.messageService.add({
      severity: 'info',
      summary: 'Product Unselected',
      detail: event.data.name,
    });
  }

  onHeaderCheckboxToggle(event) {
    this.calculation();
    let length = this.filteredDataForExport.length;
    if (event.checked) {
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Selected',
        detail: `Total ${length} Products Selected`,
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Multiple Product Unselected',
        detail: '',
      });
    }
  }

  calculation() {
    this.filteredData = [];
    // this.filteredDataForExport = event.filteredValue;
    this.totalSelectedApp = 0;
    this.totalSubToFarmer = 0;
    this.totalSubToVendor = 0;
    this.totalFarmerRefund = 0;

    this.totalSelectedApp = this.filteredDataForExport.length;
    this.filteredDataForExport.forEach((val) => {
      this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
      this.totalSubToVendor += val.SubsidyToVendor_Amount;
      this.totalFarmerRefund += val.FarmerRefund_Amount;
    });
    this.filteredDataForExport.forEach((val) => {
      this.filteredData.push({
        appID: val.Scheme_Specific_Id,
        programID: val.ProgramID,
        subsidy_Amt: 0,
        amt_Disbus_to_Vendor: 0,
        amt_Refund_to_Farmer: 0,
        // farmerShareToVendor: val.Farmer_Share_To_Vendor,
        state_share_amt: val.State_Share_Payment_Amount,
        centre_share_amt: val.Center_Share_Payment_Amount,
        topUp: val?.TopUp,
      });
    });
  }
}
